import { q as attr_style, b as attr, l as bind_props, p as pop, a as push, h as head, e as escape_html, m as stringify } from "../../../../../../../chunks/index2.js";
import { f as fallback } from "../../../../../../../chunks/utils3.js";
function FlipbookViewer($$payload, $$props) {
  push();
  let docId = $$props["docId"];
  let productId = $$props["productId"];
  let height = fallback($$props["height"], "80vh");
  let fullPage = fallback($$props["fullPage"], false);
  let initialZoom = fallback($$props["initialZoom"], "page-width");
  let flipbookAuto = fallback($$props["flipbookAuto"], false);
  const encodedFile = encodeURIComponent(`/api/product/${productId}/documents/${docId}/stream`);
  let viewerUrl = `/web/viewer.html?file=${encodedFile}`;
  $$payload.out.push(`<div class="relative overflow-hidden bg-neutral-900"${attr_style(`height:${fullPage ? "100dvh" : height}`)}><iframe title="PDF Document" class="h-full w-full svelte-8x54v0"${attr("src", viewerUrl)} loading="lazy" sandbox="allow-scripts allow-same-origin allow-popups" referrerpolicy="no-referrer"></iframe> `);
  {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="absolute inset-0 flex items-center justify-center bg-black/60 text-sm text-gray-200">Loading PDF...</div>`);
  }
  $$payload.out.push(`<!--]--> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div>`);
  bind_props($$props, {
    docId,
    productId,
    height,
    fullPage,
    initialZoom,
    flipbookAuto
  });
  pop();
}
function _page($$payload, $$props) {
  let data = $$props["data"];
  const { productId, docId, title } = data;
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>${escape_html(title)} – Viewer</title>`;
    $$payload2.out.push(`<meta name="robots" content="noindex,nofollow"/>`);
  });
  $$payload.out.push(`<div class="min-h-screen px-4 py-6 text-white"><div class="mb-4 flex items-center justify-between"><h1 class="text-xl font-semibold text-black">${escape_html(title)}</h1> <a${attr("href", `/product/${stringify(productId)}`)} class="text-primary text-sm underline-offset-2 hover:underline">Back</a></div> `);
  FlipbookViewer($$payload, { docId, productId });
  $$payload.out.push(`<!----></div>`);
  bind_props($$props, { data });
}
export {
  _page as default
};
